export const STATUS_LABELS = {
  new: "Nuevo", researched: "Investigado", emailed: "Seguimiento",
  site_generated: "Sitio Listo", paid: "Pagado", won: "Ganado", lost: "Perdido",
};

export const STATUS_ORDER = ["new", "researched", "emailed", "site_generated", "paid", "won", "lost"];
